import { useShop } from "hooks/firestore/simple/useShop"

export default function AGB({ shopId }: { shopId: string }) {
  const shop = useShop(shopId)

  if (!shop) return

  return (
    <div className="tw-min-h-screen tw-flex tw-flex-col tw-items-center">
      <div className="tw-mx-auto tw-flex tw-flex-col tw-items-center tw-max-w-3xl tw-py-24">
        <h1 className="tw-text-4xl tw-font-bold">Allgemeine Geschäftsbedingungen</h1>
        <p className="tw-mb-0 tw-mt-4 tw-prose" dangerouslySetInnerHTML={{ __html: shop?.legal?.terms ?? "" }} />
      </div>
    </div>
  )
}
